module.exports = __webpack_public_path__ + "img/bag2.fd59ad69.svg";